import { render, staticRenderFns } from "./SearchStudent.vue?vue&type=template&id=30e011fe&scoped=true"
import script from "./SearchStudent.vue?vue&type=script&lang=js"
export * from "./SearchStudent.vue?vue&type=script&lang=js"
import style0 from "./SearchStudent.vue?vue&type=style&index=0&id=30e011fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e011fe",
  null
  
)

export default component.exports